import { useContext } from 'react';
import { DialogContext, DialogContextType } from './DialogContext';

export const useDialog = (): DialogContextType => useContext(DialogContext);
